import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import { uiActions } from '../slices/uiSlice';
import type { RootState } from '../store';

import { eventsService } from './_deps';

export const joinEvent = createAsyncThunk<
  void,
  { eventId: string },
  { state: RootState }
>('events/join', async ({ eventId }, thunkApi) => {
  const { dispatch, getState } = thunkApi;

  try {
    const res = await eventsService.joinEvent({  eventId });
    dispatch(entitiesActions.patchEvent(res.event));
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Не удалось вступить';
    throw error;
  }
});

export const joinAndConfirmEvent = createAsyncThunk<
  void,
  { eventId: string },
  { state: RootState }
>('events/joinAndConfirm', async ({ eventId }, thunkApi) => {
  const { dispatch, getState } = thunkApi;

  try {
    const joinRes = await eventsService.joinEvent({  eventId });
    dispatch(entitiesActions.patchEvent(joinRes.event));

    const confirmRes = await eventsService.confirmEvent({  eventId });
    dispatch(entitiesActions.patchEvent(confirmRes.event));
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Не удалось записаться';
    throw error;
  }
});

export const leaveEvent = createAsyncThunk<void, { eventId: string }, { state: RootState }>(
  'events/leave',
  async ({ eventId }, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    try {
      const res = await eventsService.leaveEvent({  eventId });
      dispatch(entitiesActions.patchEvent(res.event));
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Не удалось выйти';
      throw error;
    }
  },
);

export const confirmEvent = createAsyncThunk<void, { eventId: string }, { state: RootState }>(
  'events/confirm',
  async ({ eventId }, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    try {
      const res = await eventsService.confirmEvent({  eventId });
      dispatch(entitiesActions.patchEvent(res.event));
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Не удалось подтвердить участие';
      throw error;
    }
  },
);
